export default __webpack_public_path__ + "static/media/close-icon.e547fa71.svg";